import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const DashboardReportSchema = withDefaults({
  type: 'dashboard-report',
  objectExtensions: ['dashboard-report'],
  fields: [
    {
      kind: 'attribute',
      name: 'position',
    },
    {
      kind: 'attribute',
      name: 'sizeConfig',
    },
    {
      kind: 'belongsTo',
      name: 'dashboard',
      type: 'dashboard',
      options: {
        async: false,
        inverse: 'dashboardReports',
      },
    },
    {
      kind: 'belongsTo',
      name: 'report',
      type: 'report',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default DashboardReportSchema;
